import React from "react";
import { CgLogIn } from 'react-icons/cg';
import Multiselect from 'multiselect-react-dropdown';


export default function UpdateQuoteModal(props) {

  let { updateLeadModal, handleUpdateLeadModalClose, errorsUpdateLead, inputChangeUpdateUser, updateLead, fieldsLeadUpdate, updateSelectedCategory, getAllCategory, onSelectUpdate, onRemoveUpdate, getAllUser, onUserSelectUpdate, onUserRemoveUpdate, updateSelectedUser,
  } = props;

  console.log("fieldsLeadUpdate.categoryListfieldsLeadUpdate.categoryList", fieldsLeadUpdate);

  let categoryData = [];
  if (updateSelectedCategory && updateSelectedCategory.length > 0) {
    updateSelectedCategory.forEach((event) => {
      categoryData.push(
        {
          name: event.name,
          id: event.id,
        }
      )
    })
  }

  let userData = [];
  if (getAllUser && getAllUser.length > 0) {
    getAllUser.forEach((event) => {
      userData.push(
        {
          userName: event.userName,
          email: event.email,
          _id: event._id,
        }
      )
    })
  }


  console.log('categoryData___UPDATE____MODAL???????', userData);
  // console.log('updateSelectedCategory_______MODAL???????', updateSelectedCategory);

  return (


    <div className={updateLeadModal ? "fixed w-full lg:left-24 left-0 h-full inset-0 z-40 overflow-hidden mt-0 flex justify-center items-center overflow-y-auto bg-black/40 md:p-0 p-1" : "hidden"} style={{ marginTop: '0rem', }}  >
      <div className="animate__animated animate__fadeInDown animate__faster bg-[#f8f8fb] md:w-[38rem] w-full mx-auto rounded shadow-lg overflow-y-auto mt-2">
        <div className="flex items-center justify-between p-6 py-2 bg-blue-500 border-b">
          <p className="text-[16px] font-medium text-white uppercase">Update Lead </p>
          <div className="rounded-full cursor-pointer modal-close ">
            <svg onClick={() => handleUpdateLeadModalClose()} className="fill-current text-white/60 hover:text-white/100 " xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 18 18">
              <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z">
              </path>
            </svg>
          </div>
        </div>

        <div className="p-4">
          <form autoComplete="off" className="p-4 space-y-4 capitalize border border-gray-300 ">
            <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="username">Name :</label>
                <input className={`w-full p-2 mt-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 ring-gray-500   ${errorsUpdateLead && !errorsUpdateLead["name"] ? "border  placeholder-gray-500" : "border  border-red-500 "}`}
                  id="name" name="name" placeholder="Name..." value={fieldsLeadUpdate && fieldsLeadUpdate.name ? fieldsLeadUpdate.name : null} type="text" onChange={inputChangeUpdateUser} />
                {errorsUpdateLead && errorsUpdateLead["name"] ?
                  <div className="text-xs text-red-500 invalid-feedback">
                    {errorsUpdateLead["name"]}
                  </div>
                  : null}
              </div>

              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="username">Date :</label>
                <input className={` w-full p-2 mt-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 ring-gray-500  ${errorsUpdateLead && !errorsUpdateLead["calenderDate"] ? "border  placeholder-gray-500" : "border  border-red-500 "}`}
                  id="calenderDate" name="calenderDate" placeholder="Date..." value={fieldsLeadUpdate && fieldsLeadUpdate.calenderDate ? fieldsLeadUpdate.calenderDate : null} type="date" onChange={inputChangeUpdateUser} />
                {errorsUpdateLead && errorsUpdateLead["calenderDate"] ?
                  <div className="text-xs text-red-500 invalid-feedback">
                    {errorsUpdateLead["calenderDate"]}
                  </div>
                  : null}
              </div>

              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="username">Mobile Number :</label>
                <input className={` w-full p-2 mt-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 ring-gray-500  ${errorsUpdateLead && !errorsUpdateLead["requirement"] ? "border  placeholder-gray-500" : "border  border-red-500 "}`}
                  id="mobNo" name="mobNo" placeholder="Requirement..." value={fieldsLeadUpdate && fieldsLeadUpdate.mobNo ? fieldsLeadUpdate.mobNo : null} type="text" onChange={inputChangeUpdateUser} />
                {errorsUpdateLead && errorsUpdateLead["mobNo"] ?
                  <div className="text-xs text-red-500 invalid-feedback">
                    {errorsUpdateLead["mobNo"]}
                  </div>
                  : null}
              </div>

              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="username">Email :</label>
                <input className={` w-full p-2 mt-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 ring-gray-500  ${errorsUpdateLead && !errorsUpdateLead["requirement"] ? "border  placeholder-gray-500" : "border  border-red-500 "}`}
                  id="email" name="email" placeholder="Requirement..." value={fieldsLeadUpdate && fieldsLeadUpdate.email ? fieldsLeadUpdate.email : null} type="text" onChange={inputChangeUpdateUser} />
                {errorsUpdateLead && errorsUpdateLead["email"] ?
                  <div className="text-xs text-red-500 invalid-feedback">
                    {errorsUpdateLead["email"]}
                  </div>
                  : null}
              </div>
              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="username">Requirement :</label>
                <textarea rows={3} className={` w-full p-2 mt-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 ring-gray-500  ${errorsUpdateLead && !errorsUpdateLead["requirement"] ? "border  placeholder-gray-500" : "border  border-red-500 "}`}
                  id="requirement" name="requirement" placeholder="Requirement..." value={fieldsLeadUpdate && fieldsLeadUpdate.requirement ? fieldsLeadUpdate.requirement : null} type="text" onChange={inputChangeUpdateUser} />
                {errorsUpdateLead && errorsUpdateLead["requirement"] ?
                  <div className="text-xs text-red-500 invalid-feedback">
                    {errorsUpdateLead["requirement"]}
                  </div>
                  : null}
              </div>

              {/* <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="username">Source :</label>
                <input className={`w-full p-2 mt-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 ring-gray-500  ${errorsUpdateLead && !errorsUpdateLead["city"] ? "border  placeholder-gray-500" : "border  border-red-500 "}`}
                  id="source" name="source" placeholder="Source..." value={fieldsLeadUpdate && fieldsLeadUpdate.source ? fieldsLeadUpdate.source : null} type="text" onChange={inputChangeUpdateUser} />
                {errorsUpdateLead && errorsUpdateLead["source"] ?
                  <div className="text-xs text-red-500 invalid-feedback">
                    {errorsUpdateLead["source"]}
                  </div>
                  : null}
              </div> */}

              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="username">Select Category :</label>
                <Multiselect
                  options={getAllCategory}
                  // options={categoryData} 
                  // selectedValues={selectedValue}
                  onSelect={onSelectUpdate}
                  onRemove={onRemoveUpdate}
                  displayValue="name"
                  selectedValues={fieldsLeadUpdate.categoryList}
                />
              </div>

              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="username">Select User :</label>

                <Multiselect
                  options={userData}
                  // options={categoryData}
                  // selectedValues={selectedValue}
                  onSelect={onUserSelectUpdate}
                  onRemove={onUserRemoveUpdate}
                  displayValue="userName"
                  selectedValues={fieldsLeadUpdate.assigneeList}
                />
              </div>
              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="status">Select Status :</label>
                <select id="status" name="status" className="w-full p-2 mt-1 text-sm border border-gray-300 rounded-md focus:outline-none focus:ring-2 ring-gray-500" value={fieldsLeadUpdate && fieldsLeadUpdate.status ? fieldsLeadUpdate.status : null} onChange={inputChangeUpdateUser}>
                  <option value="NEW">NEW</option>
                  <option value="CONTACTED">CONTACTED</option>
                  <option value="QUALIFIED">QUALIFIED</option>
                  <option value="CONVERTED">CONVERTED</option>
                  <option value="LOST">LOST</option>
                </select>
              </div>

              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="location">location :</label>
                <input className={`w-full p-2 mt-1 text-sm  border-gray-300 rounded-md focus:outline-none focus:ring-2 ring-gray-500  border  placeholder-gray-500   "}`}
                  id="location" name="location" placeholder="location..." value={fieldsLeadUpdate && fieldsLeadUpdate.location ? fieldsLeadUpdate.location : ""} type="text" onChange={inputChangeUpdateUser} />
                {errorsUpdateLead && errorsUpdateLead["location"] ?
                  <div className="text-xs text-red-500 invalid-feedback">
                    {errorsUpdateLead["location"]}
                  </div>
                  : null}
              </div>

              <div className="w-full">
                <label className="block text-xs font-medium text-gray-500 md:text-left" for="companyName">companyName :</label>
                <input className={`w-full p-2 mt-1 text-sm  border-gray-300 rounded-md focus:outline-none focus:ring-2 ring-gray-500  border  placeholder-gray-500   "}`}
                  id="companyName" name="companyName" placeholder="companyName..." value={fieldsLeadUpdate && fieldsLeadUpdate.companyName ? fieldsLeadUpdate.companyName : ""} type="text" onChange={inputChangeUpdateUser} />
                {errorsUpdateLead && errorsUpdateLead["companyName"] ?
                  <div className="text-xs text-red-500 invalid-feedback">
                    {errorsUpdateLead["companyName"]}
                  </div>
                  : null}
              </div>
            </div>
            <div className="flex justify-end pt-10 space-x-4">
              <button className="bg-blue-500  transition duration-150 text-white text-[.8125rem]  px-3 py-2 rounded-[.25rem] flex items-center hover:bg-[#f14646] " type="button"
                onClick={updateLead}
              >Submit
                <CgLogIn size={18} className="ml-2" />
              </button>
            </div>

          </form>

        </div>
        {/*Footer*/}

      </div >
    </div >

  );
}
